import React from 'react';

import styles from './ExploratoryPageExtraContentContainer.module.scss';

export const ExploratoryPageExtraContentContainer = () => {
    return (
        <section className={styles.root}>
            <p>placeholder extra content / footer section</p>
        </section>
    );
};
